import React from 'react'

export default function Background ({background,children}) {
  return (
    <div className='bg-container' style={{background:`url(${background})`}}>
        {children}
    </div>
  )
}
